// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
__webpack_require__("../../deps/sparta-platform/6.10.3/package/node_modules/core-js/stable/index.js");
__webpack_require__("../../deps/sparta-platform/6.10.3/package/node_modules/regenerator-runtime/runtime.js");
var __webpack_exports__ = __webpack_require__("../../deps/sparta-platform/6.10.3/package/node_modules/element-polyfill/index.js");
